import React from "react";
import useStyles from "../../styles";

const Heading = () => {
    const cl = useStyles();

    return (<div className={cl.orderAssaysHeadingWrapper}>
        <div className={cl.orderAssaysHeading}>
            <div className={cl.orderAssaysHeadingBox}>
                <p className={cl.orderAssayHeadingTextName}>Назва дослідження</p>
            </div>
            <div className={cl.orderAssaysHeadingBox}>
                <div className={cl.orderAssaysHeadingSmallBox}>
                    <p className={cl.orderAssayHeadingText}>Термін</p>
                    <p className={cl.orderAssayHeadingTextSmall}>(робочих днів)</p>
                </div>
                <div className={cl.orderAssaysHeadingSmallBoxDesc}>
                    <p className={cl.orderAssayHeadingText}>Дослідження</p>
                    <p className={cl.orderAssayHeadingText}>у комплексі</p>
                </div>
                <div className={cl.orderAssaysHeadingSmallBoxDesc}>
                    <p className={cl.orderAssayHeadingText}>Ціна</p>
                    <p className={cl.orderAssayHeadingTextSmall}>(у відділенні)</p>
                </div>
                <div className={cl.orderAssaysHeadingSmallBox}>
                    <p className={cl.orderAssayHeadingText}>Ціна онлайн</p>
                </div>
            </div>
        </div>
    </div>)
};

export default Heading;
